// Public pages are cached and never read the session cookie, so the header
// can't know who is signed in. The server sets a readable `dvs_signed_in=1`
// cookie next to the httponly session cookie and deletes it on sign out; the
// header reads it and swaps its links. It grants nothing: /account still checks
// the real session and sends a stale hint to /login.
export const HINT_COOKIE = 'dvs_signed_in'

export function isSignedIn(cookie: string = document.cookie): boolean {
  return cookie.split(';').some((part) => part.trim() === `${HINT_COOKIE}=1`)
}

// <a data-signed-out-only>Sign in</a> hides and <a data-signed-in-only hidden>Account</a>
// shows once signed in.
export function applySessionHint(root: ParentNode = document, cookie: string = document.cookie): void {
  if (!isSignedIn(cookie)) return
  root.querySelectorAll<HTMLElement>('[data-signed-out-only]').forEach((el) => (el.hidden = true))
  root.querySelectorAll<HTMLElement>('[data-signed-in-only]').forEach((el) => (el.hidden = false))
}
